import * as React from "react"
import { Dialog, DialogTitle, DialogContent, Button, ButtonBase } from '@mui/material'
import { ModuleTypes } from '../../Module/_config/ModuleInfo'
import { Trans } from 'react-i18next'
import { Close } from "@mui/icons-material"

export type Props = {
	opened?:boolean
	addModule?: Function
	updateModule?: Function
	setIntroOpen?: Function
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class IntroDialog extends React.Component<Props> {
	private onAddImage = () => {
		let id = this.props.addModule(ModuleTypes.Image);

		this.onClose();
		//Something about auto pattern size.. maybe a prop on the module
		//Maybe add something about repeats.. not sure
	}

	private onChoosePattern = () => {
		let id = this.props.addModule(ModuleTypes.PatternDesignService);

		this.onClose();
		//Something about auto pattern size.. maybe a prop on the module
		//Maybe add something about repeats.. not sure
	}

	private onClose = () => {
		this.props.setIntroOpen(false);
	}

	render() { 
		return <Dialog role="dialog" className="large-dialog intro-dialog" open={this.props.opened} onClose={() => this.onClose()}>
			<DialogTitle><T>Welcome to your Pattern Lab!</T></DialogTitle>
			<ButtonBase><Close className="close-icon" onClick={() => this.onClose()} /></ButtonBase>
			<DialogContent>
				<div className="col left">
					<img src="/static/img/lab/intro/blank-design.svg"/>
					<h3><span><T>Start blank</T></span></h3>
					<p className="description"><T>Start from a blank 8" x 8" template and use any of the tools to create something from nothing.</T></p>
					<Button color="secondary" className="secondary-primary" onClick={() => this.onClose()}><T>Start blank</T></Button>
				</div>
				<div className="col left">
					<img src="/static/img/lab/intro/image-design.svg"/>
					<h3><span><T>Upload your image</T></span></h3>
					<p className="description"><T>Upload an image of any size and we'll automatically turn it into a pattern for you.</T></p>
					<Button color="secondary" className="secondary-primary" onClick={this.onAddImage}><T>Add Image</T></Button>
				</div>
				<div className="col">
					<img src="/static/img/lab/intro/pattern-design.svg"/>
					<h3><span><T>Use a pattern from the patterndesigns.com library</T></span></h3>
					<p className="description"><T>Choose a pattern from the thousands of original patterns from the patterndesigns.com library.</T></p>
					<Button color="secondary" className="secondary-primary" onClick={this.onChoosePattern}><T>Choose Pattern</T></Button>
				</div>
			</DialogContent>
		</Dialog>
	}
}